import { ScoreHealthRangeBreakpoint } from '../../..';

export const SAVINGS_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS: ScoreHealthRangeBreakpoint[] = [
  { category: 'atypicallyLow', min: 0, max: 0.05, id: 'atypicallyLow_Sr' },
  { category: 'low', min: 0.05, max: 0.1, id: 'low_Sr' },
  { category: 'typical', min: 0.1, max: 0.2, id: 'typical_Sr' },
  { category: 'high', min: 0.2, max: 0.3, id: 'high_Sr' },
  { category: 'atypicallyHigh', min: 0.3, max: 1, id: 'atypicallyHigh_Sr' },
];
